import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth-slice";
import gamesReducer from "./home-page";
import devlogSlice from "./devlog-slice";
import seoSettingReducer from "./common-slice";
const store = configureStore({
    reducer: {
        auth: authReducer,
        games: gamesReducer,
		seoSetting: seoSettingReducer,
		devlogs: devlogSlice
    },
});

export default store;